import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../form/Form";
import FormRequiredLabel from "../label/FormRequiredLabel";
import { Input } from "../input/Input";
import { useFormContext } from "react-hook-form";

const FileInput = ({
  name,
  label,
  placeholder,
  required = false,
  disabled = false,
}) => {
  const { control } = useFormContext();

  return (
    <div>
      <FormField
        control={control}
        name={name}
        render={({ field: { value, onChange, ...fieldProps } }) => (
          <FormItem>
            {required ? (
              <FormRequiredLabel text={label} />
            ) : (
              <FormLabel>{label}</FormLabel>
            )}
            <FormControl>
              <Input
                {...fieldProps}
                type="file"
                accept="text/csv"
                placeholder={placeholder}
                disabled={disabled}
                onChange={(event) => {
                  console.log(event.target.files);
                  onChange(event.target.files);
                }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      ></FormField>
    </div>
  );
};

export default FileInput;
